import { ActionTypes } from "../constants/action-types";

export  const setPriceAction = payload => ({
  type: ActionTypes.PRICE_FILTER,
  payload: payload
})